module.exports = __webpack_public_path__ + "static/media/P1-perfil-compras-no-compras-activas-imagen.0f2bef71.png";